// import React, { useState, useEffect, useRef } from "react";
// import { generateClient } from "aws-amplify/api";
// import Leaderboard from "./Leaderboard";
// import DrawingCanvas from "./DrawingCanvas";
// import CardComponent from "./CardComponent";
// import AudioComponent from "./AudioComponent";
// import "../styles/GameBoard.css";

// const client = generateClient();

// const GameBoard = ({ gameId, gameName, username, themes, onBack }) => {
//   const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);
//   const [timerActive, setTimerActive] = useState(false);
//   const [drawingSubmitted, setDrawingSubmitted] = useState(false);
//   const [audioSubmitted, setAudioSubmitted] = useState(false);
//   const cardComponentRef = useRef();

//   useEffect(() => {
//     setTimerActive(true);
//   }, []);

//   useEffect(() => {
//     if (drawingSubmitted && audioSubmitted) {
//       cardComponentRef.current.stopTimer();
//     }
//   }, [drawingSubmitted, audioSubmitted]);

//   const openLeaderboard = () => {
//     setIsLeaderboardOpen(true);
//   };

//   const closeLeaderboard = () => {
//     setIsLeaderboardOpen(false);
//   };

//   const handleDrawingSubmit = () => {
//     setDrawingSubmitted(true);
//   };

//   const handleAudioSubmit = () => {
//     setAudioSubmitted(true);
//   };

//   return (
//     <div>
//       <h1 className="gameboard-title">Welcome to {gameName}, {username}! </h1>
//       <button onClick={onBack} className="back-button">
//         Back to Games
//       </button>
//       <button onClick={openLeaderboard} className="info-button">
//         View Leaderboard
//       </button>
      
//       {isLeaderboardOpen && (
//         <div className="modal-overlay">
//           <div className="leaderboard-modal">
//             <button onClick={closeLeaderboard} className="close-modal-button">
//               X
//             </button>
//             <Leaderboard gameId={gameId} client={client} />
//           </div>
//         </div>
//       )}

//       <CardComponent 
//         gameId={gameId} 
//         client={client} 
//         ref={cardComponentRef}
//         timerActive={timerActive}
//       />
//       <AudioComponent 
//         gameId={gameId} 
//         client={client} 
//         playerId={username} 
//         onSubmit={handleAudioSubmit}
//       />
//       <DrawingCanvas 
//         gameId={gameId} 
//         playerUsername={username} 
//         themes={themes}
//         onSubmit={handleDrawingSubmit}
//       />
//     </div>
//   );
// };

// export default GameBoard;

import React, { useState, useEffect, useRef } from "react";
import { generateClient } from "aws-amplify/api";
import Leaderboard from "./Leaderboard";
import DrawingCanvas from "./DrawingCanvas";
import CardComponent from "./CardComponent";
import AudioComponent from "./AudioComponent";
import "../styles/GameBoard.css";

const GameBoard = ({ gameId, gameName, username, themes, onBack }) => {
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);
  const [timerActive, setTimerActive] = useState(false);
  const [drawingSubmitted, setDrawingSubmitted] = useState(false);
  const [audioSubmitted, setAudioSubmitted] = useState(false);
  const cardComponentRef = useRef();
  const client = generateClient();

  useEffect(() => {
    setTimerActive(true);
  }, []);

  useEffect(() => {
    if (drawingSubmitted && audioSubmitted) {
      cardComponentRef.current?.stopTimer();
    }
  }, [drawingSubmitted, audioSubmitted]);

  const handleLeaderboardToggle = () => setIsLeaderboardOpen(!isLeaderboardOpen);
  const handleAudioSubmit = () => setAudioSubmitted(true);
  const handleDrawingSubmit = () => setDrawingSubmitted(true);

  return (
    <div className="gameboard-container">
      
      <header className="header">
        <h1 className="gameboard-title">Welcome {username}</h1>
        <nav className="nav-buttons">
          <button onClick={onBack} className="control-button">
            Back to Games
          </button>
          <button onClick={handleLeaderboardToggle} className="control-button">
            View Leaderboard
          </button>
        </nav>
      </header>

      <main className="gameboard-layout">
        <div className="card-section">
          <CardComponent 
            gameId={gameId} 
            client={client} 
            ref={cardComponentRef}
            timerActive={timerActive}
          />
        </div>
        
        <div className="audio-section">
          <AudioComponent 
            gameId={gameId} 
            client={client} 
            playerId={username} 
            onSubmit={handleAudioSubmit}
          />
        </div>

        <div className="drawing-section">
          <DrawingCanvas 
            gameId={gameId} 
            playerUsername={username} 
            themes={themes}
            onSubmit={handleDrawingSubmit}
          />
        </div>
      </main>

      {isLeaderboardOpen && (
        <div className="modal-overlay">
          <div className="leaderboard-modal">
            <button 
              onClick={handleLeaderboardToggle} 
              className="close-modal-button"
              aria-label="Close leaderboard"
            >
              ×
            </button>
            <Leaderboard gameId={gameId} client={client} />
          </div>
        </div>
      )}
    </div>
  );
};

export default GameBoard;

